/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import Typography from '@mui/material/Typography';
import { NavLink, useParams } from "react-router-dom";
import { Row, Col, Image, Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Switch, FormControlLabel, Button, Box, TableCell, TableRow } from "@mui/material";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import clsx from "clsx";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import crudActions from "../../../../CRUD/redux/actions";
import { toast } from 'react-toastify';
import { CustomAccordion } from "../../../../Shared/components/AccordionComponent";
import PrimaryTable from "../../../../Shared/components/PrimaryTable";
import { gabLinkedAccountsHead } from "../../../../../config/constant";
import usePrevious from "../../../../Shared/components/Previous";
import { checkCRUDViewPermission, exportCommonFile } from '../../../../../helpers/utilities';

const GlobalAddressView = (props) => {
    const [isGloballyVisible, setIsGloballyVisible] = useState(true);
    const [isPrimary, setIsPrimary] = useState(false);
    const { readDetails, readLoader, editDetails, editError, editLoader } = useSelector(state => state.crudReducer);

    const { addressId } = useParams();
    const dispatch = useDispatch();
    const { history } = props;
    const prevEditDetails = usePrevious(editDetails);
    const childRef = useRef('');
    const [sortOrder, setSortOrder] = useState("asc");
    const [sortBy, setSortBy] = useState("");
    const [showDetails, setShowDetails] = useState(true);
    const [saveVisible, setSaveVisible] = useState(false);

    const { roleManagement } = useSelector(state => state.authReducer);

    useEffect(() => {
        if (addressId === undefined) {
            history.push("/sales/sales-management/all-customers");
        }
        if (roleManagement !== '' && checkCRUDViewPermission("Global Address Book", 'view', history, 'Younote Admin')) {
            dispatch({ type: crudActions.READ_DETAILS_START, id: addressId, url: "addressBook" });
        }
    }, [addressId, roleManagement]);


    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch({
            type: crudActions.EDIT_DETAILS_START,
            url: 'addressBook',
            title: 'Address Book',
            id: addressId,
            details: {
                isGloballyVisible: isGloballyVisible,
                //  isPrimary: isPrimary,
            }
        });
    }

    useEffect(() => {
        if (readDetails) {
            setIsGloballyVisible(readDetails.isGloballyVisible);
            setIsPrimary(readDetails.isPrimary);
            setShowDetails(false);
            childRef?.current?.handleAdjustHeight();
        }
    }, [readDetails]);

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            toast.dismiss();
            toast(editDetails);
            history.push("/younote-admin/home/global-address-book");
        } else if (editError) {

        }
    }, [editDetails, editError]);

    const onRequestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatch({
            type: crudActions.READ_DETAILS_START,
            url: 'addressBook',
            id: addressId
        });
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props} img={SettingsImg} title={'Admin'} links={[{ 'label': 'Younote Admin', 'link': '/admin' }, { 'label': 'Global Address Book', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.listTableSticky, { [classes.scrollBorder]: !showDetails })}>
                <div id="containerDiv" className={clsx(classes.stickyContainer)}>
                    <CustomAccordion
                        title={'Global Address Book Details'}
                        top={"0"}
                        topVisible={"50px"}
                        zIndex={9}
                        showDetails={showDetails}
                        index={0}
                        ref={childRef}
                        component={
                            <>
                                {
                                    showDetails === false && readDetails &&
                                    <Box
                                        className={clsx(classes.removeUnderline)}
                                        component="form"
                                        autoComplete="off"
                                        onSubmit={(e) => handleSubmit(e)}
                                    >


                                        <Row align="top" gutter={50}>

                                            <Col xxl={5} xl={5} lg={2} md={2} sm={12} xs={12}>
                                                <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}>General</Typography>
                                            </Col>
                                            <Col xxl={19} xl={19} lg={22} md={22} sm={12} xs={12} className={clsx(classes.removeUnderline, classes.textAlignRight)}>
                                                <Space size={[10, 10]} direction="horizontal" align="center">
                                                    {/* <Button
                                                key="delete"
                                                color="primary"
                                                onClick={() => onDelete(readDetails)}
                                                variant="contained"
                                                className={clsx(classes.deleteBtn, classes.marginRight0, { [classes.loading]: deleteLoader })}
                                            >Delete</Button> */}
                                                    {
                                                        saveVisible ?
                                                            <Button
                                                                key="save"
                                                                type="submit"
                                                                color="primary"
                                                                variant="contained"
                                                                className={clsx(classes.modalBtn, classes.marginRight0, { [classes.loading]: editLoader })}
                                                            >Save</Button> : <Button
                                                                key="edit"
                                                                color="primary"
                                                                variant="contained"
                                                                onClick={() => setSaveVisible(true)}
                                                                className={clsx(classes.modalBtn, classes.marginRight0, { [classes.loading]: editLoader })}
                                                            >Edit</Button>
                                                    }

                                                </Space>
                                            </Col>
                                        </Row>

                                        <Row gutter={50}>
                                            <Col xxl={16} xl={16} lg={16} md={24} sm={24} xs={24}>
                                                <Row gutter={50}>
                                                    <Col xxl={12} xl={12} lg={12} md={8} sm={12} xs={24}>
                                                        <Typography className={clsx(classes.aTitle, classes.bold)}>{readDetails.businessName ? readDetails.businessName : readDetails.contactName}</Typography>
                                                        <Typography className={clsx(classes.fonSize13)}>{readDetails?.userId ? 'YOU' + readDetails?.userId : (readDetails?.businessId ? 'YOU' + readDetails?.businessId : '--')}</Typography>
                                                    </Col>

                                                    <Col xxl={12} xl={12} lg={12} md={8} sm={12} xs={24} >
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.gabId, 'MuiInputLabel-shrink', classes.fonSize13)}>GAB Id</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>GABID{readDetails.id}</Typography>
                                                    </Col>

                                                    <Col xxl={12} xl={12} lg={12} md={8} sm={12} xs={24}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.globalMobileView, classes.fonSize13)}>Mobile Number </Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.mobile ? readDetails.mobile : '---'}</Typography>
                                                    </Col>

                                                    <Col xxl={12} xl={12} lg={12} md={8} sm={12} xs={24}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Email</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.email ? readDetails.email : '---'}</Typography>
                                                    </Col>
                                                    <Col xxl={12} xl={12} lg={12} md={8} sm={12} xs={24}>
                                                        <FormControlLabel
                                                            classes={{
                                                                label: clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13) // Pass your override css here
                                                            }}
                                                            control={<Switch size='small'
                                                                className={clsx(classes.customSwitch)}
                                                                onChange={(e) => setIsGloballyVisible(!isGloballyVisible)}
                                                            />}
                                                            label="Global Visibility"
                                                            labelPlacement="top"
                                                            checked={isGloballyVisible}
                                                            className={clsx(classes.marginLeft0, classes.margin30t, classes.flexStart)}
                                                        />
                                                    </Col>
                                                    <Col xxl={12} xl={12} lg={12} md={8} sm={12} xs={24}>
                                                        <FormControlLabel
                                                            classes={{
                                                                label: clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13) // Pass your override css here
                                                            }}
                                                            control={<Switch size='small' className={clsx(classes.customSwitch)} />}
                                                            label="Primary"
                                                            labelPlacement="top"
                                                            checked={isPrimary}
                                                            className={clsx(classes.marginLeft0, classes.margin30t, classes.flexStart)}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col xxl={8} xl={8} lg={8} md={24} sm={24} xs={24}>
                                                <Row gutter={50}>
                                                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                        <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.globalAddressView, classes.bold)}>Address</Typography>
                                                    </Col>
                                                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                        <Row gutter={50} className={classes.globalView}>
                                                            <Col xxl={24} xl={24} lg={24} md={8} sm={12} xs={24}>
                                                                <Typography className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.globalAddressBookView, classes.margin55t, classes.fonSize13)}>Address Line 1</Typography>
                                                                <Typography className={clsx(classes.fonSize13)}>{readDetails.address1 ? readDetails.address1 : '---'}</Typography>
                                                            </Col>
                                                            <Col xxl={24} xl={24} lg={24} md={8} sm={12} xs={24} >
                                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Area</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.area ? readDetails.area.name : '---'}</Typography>
                                                            </Col>
                                                            <Col xxl={12} xl={12} lg={12} md={8} sm={12} xs={24} >
                                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Pincode</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.pincode ? readDetails.pincode.code : '---'}</Typography>
                                                            </Col>
                                                            <Col xxl={12} xl={12} lg={12} md={8} sm={12} xs={24} >
                                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Dist/City/Town</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.city ? readDetails.city.name : '---'}</Typography>
                                                            </Col>
                                                            <Col xxl={12} xl={12} lg={12} md={8} sm={12} xs={24} >
                                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>State</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.state ? readDetails.state.name : '---'}</Typography>
                                                            </Col>
                                                            <Col xxl={12} xl={12} lg={12} md={8} sm={12} xs={24} >
                                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Country</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.country ? readDetails.country.name : '---'}</Typography>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Box>


                                }
                                {
                                    showDetails === true && (
                                        <div className={classes.textAlignCenter}>
                                            <div className={classes.loadMoreCircle}></div>
                                        </div>
                                    )
                                }
                            </>
                        }
                    />
                    <CustomAccordion
                        title={'Linked Accounts'}
                        top={"49"}
                        topVisible={"150px"}
                        zIndex={7}
                        showDetails={showDetails}
                        index={1}
                        ref={childRef}
                        component={
                            <>
                                <Row>
                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                        <Typography className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}> Total Accounts Linked {readDetails?.accounts ? readDetails?.accounts?.length : 0}</Typography>
                                    </Col>
                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className={classes.textAlignRight}>
                                        <Space size={[18, 18]} direction="horizontal" align="center">
                                            <NavLink
                                                to="#"
                                                onClick={() =>  exportCommonFile('Address Book Lines', readDetails?.accounts)}
                                                className={clsx(classes.customLink)}>
                                                <Image
                                                    src={ExportIcon}
                                                    preview={false}
                                                    className={clsx(classes.antImage)}
                                                /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                            </NavLink>
                                        </Space>
                                    </Col>
                                </Row>
                                <PrimaryTable
                                    heads={gabLinkedAccountsHead}
                                    sortOrder={sortOrder}
                                    sortBy={sortBy}
                                    onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                                    component={
                                        <>
                                            {

                                                readLoader === false && readDetails && readDetails?.accounts && readDetails.accounts?.length > 0 && readDetails?.accounts?.map((data, i) => (
                                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i}>
                                                        <TableCell className={clsx(classes.color, classes.bold)}>{data?.relGabId || '---'}</TableCell>
                                                        <TableCell>{data.businessId ? `YOU${data.businessId}` : '---'}</TableCell>
                                                        <TableCell>{data?.relGab?.businessName || data?.relGab?.contactName || '---'}</TableCell>
                                                        <TableCell>{data?.userType || '---'}</TableCell>
                                                    </TableRow>
                                                ))
                                            }
                                            {
                                                readLoader === false && readDetails.accounts === undefined && (
                                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                        <TableCell style={{ textAlign: "center" }} colSpan={4}>
                                                            <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>There are no Linked Business to this user</p>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            }
                                            {
                                                readLoader === true && (
                                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}><TableCell style={{ textAlign: "center" }} colSpan={4} ><div className={classes.loadMoreCircle}></div></TableCell></TableRow>
                                                )
                                            }
                                        </>
                                    }
                                />

                            </>
                        }
                        lastContent={true}
                    />
                </div>
            </div>
        </React.Fragment>
    )
}
export default GlobalAddressView;